import { withStyles } from '@material-ui/core';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import PF2MTabs from '~/components/PF2MTabs';
import EquipmentProgramsTab from './EquipmentProgramsKanbanTab';
import PendenciesTab from './PendenciesTab';
import styles from './styles';

const EquipmentPrograms = () => {
  const [selectedTab, setSelectedTab] = useState(0);
  const { t: translate } = useTranslation();

  const tabs = [
    { key: 0, label: translate('common:EquipmentScheduling') },
    { key: 1, label: translate('common:PendenciesApproval') },
  ];

  const handleChange = (event, value) => setSelectedTab(value);

  return (
    <>
      <PF2MTabs
        value={selectedTab}
        onChange={handleChange}
        indicatorColor="primary"
        textColor="primary"
        hideSyncButton
      >
        {tabs}
      </PF2MTabs>
      {selectedTab === 0 ? (<EquipmentProgramsTab />) : null}
      {selectedTab === 1 ? (<PendenciesTab />) : null}
    </>
  );
};

export default withStyles(styles)(EquipmentPrograms);
